import { createClient } from 'contentful';
import entries from '../../cypress/fixtures/entries.json';
import { ContentfulTags } from '../enums/ContentfulTags';

const space = process.env.CONTENTFUL_SPACE_ID;
const accessToken = process.env.CONTENTFUL_ACCESS_TOKEN;

let client;
if (process.env.CYPRESS_SPECIFIC_CI === 'true') {
  client = {
    getEntries: () => {
      return Promise.resolve(entries);
    },
    getFeaturedPosts: () => {
      return Promise.resolve(entries);
    },
  };
} else {
  client = createClient({
    space,
    accessToken,
  });
}

const convertImage = (rawImage) => {
  if (rawImage) {
    return {
      imageUrl: rawImage.file.url.replace('//', 'http://'), // may need to put null check as well here
      // description: rawImage.description,
      title: rawImage.title,
    };
  }
  return null;
};

// Convert and validate raw post data.
// Returns formatted post (or null if invalid).
const convertPost = (rawData) => {
  const rawPost = rawData.fields;
  const rawCoverImage = rawPost.coverImage ? rawPost.coverImage.fields : null;

  // A post is not valid if it's missing a slug.
  if (!rawPost.slug) {
    return null;
  }

  return {
    id: rawData.sys.id,
    body: rawPost.body,
    publishedAt: rawPost.publishedAt,
    updatedAt: rawData.sys.updatedAt,
    slug: rawPost.slug,
    contentfulTags: rawData.metadata.tags.map((tag) => tag.sys.id),
    tags: rawPost.tags ?? [],
    title: rawPost.title,
    subTitle: rawPost.subTitle ?? null,
    videoUrl: rawPost.videoUrl || null,
    coverImage: convertImage(rawCoverImage),
    author: rawPost.author,
    showCTAs: rawPost.showCtAs == null ? true : rawPost.showCtAs,
  };
};

export type Post = {
  id: string;
  body: string;
  publishedAt: string;
  updatedAt: string;
  slug: string;
  contentfulTags: string[];
  tags: string[];
  title: string;
  subTitle: string;
  videoUrl: string | null;
  coverImage: any;
  author: string;
  showCTAs: boolean;
};
export const getFeaturedPosts = async (): Promise<Post[]> => {
  return client
    .getEntries({
      content_type: 'blogPost',
      'metadata.tags.sys.id[in]': ContentfulTags.FEATURED,
    })
    .then((entries) => {
      if (entries && entries.items && entries.items.length > 0) {
        const blogPosts = entries.items.reduce((acc, entry) => {
          const post = convertPost(entry);
          if (post) {
            acc.push(post);
          }
          return acc;
        }, []);
        return blogPosts;
      }
      return [];
    });
};

export const fetchEntries = async (): Promise<Post[]> => {
  return client
    .getEntries({
      limit: 1000,
      content_type: 'blogPost',
      order: '-sys.createdAt',
    })
    .then((entries) => {
      if (entries && entries.items && entries.items.length > 0) {
        const blogPosts = entries.items.reduce((acc, entry) => {
          const post = convertPost(entry);
          if (post) {
            acc.push(post);
          }
          return acc;
        }, []);
        return blogPosts;
      }
      return [];
    });
};

export const fetchEntryById = async (postData) => {
  const { content_type, slug } = postData;
  return client
    .getEntries({
      content_type,
      'fields.slug[in]': slug,
    })
    .then((entries) => {
      if (entries && entries.items && entries.items.length > 0) {
        // Assuming it always have unique slug for every blog entry
        const post = convertPost(entries.items[0]);
        return post;
      }
      return null;
    });
};
